import {setServer} from "@/utils/axios";
const request = setServer();
// 查询按钮权限
export function getButtonLimit(data) {
  return request({
    url: '/permission/button' ,
    method: 'post',
    data:data
  })
}

// 查全部询权限
export function getAllPermission(data) {
  return request({
    url: '/permission/refer-user',
    method: 'post',
    data: data
  })
}

// 查全部询权限下拉
export function getPermissionRefer(data) {
  return request({
    url: '/permission/v2/refer/directory',
    method: 'post',
    data: data
  })
}

// 查询权限下拉框数据
export function getSysPermission(data) {
  return request({
    url: '/permission/refer',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/permission/index.js